<template>

  <v-app>


    <!-- banner -->
    <BannerBlog></BannerBlog>


    <!-- content post -->
  	<v-container class="mt-10 mb-10" v-if="post.content != null">

  		<v-row>

  			<v-col offset-lg="2" lg="8" offset-sm="1" sm="10" offset="0" cols="12">

          <h1 class="text-center">{{ post.title }}</h1>

          <v-row class="mt-5 mb-5">
            <v-col offset-md="2" md="8" offset="1" cols="10">
              <img :src="backend+'../storage/app/'+post.img" width="100%" />
            </v-col>
          </v-row>

  				<div v-html="post.content"></div>

  				<p>
  					<small style="color: gray;"><b><i>Publicado el {{dateFormat2(post.created_at)}}</i></b></small>
  				</p>

  			</v-col>

  		</v-row>
  		
  	</v-container>

  </v-app>  

</template>


<script>
  
  import BannerBlog from './../components/BannerBlog'

  import BlogService from '@/shared/services/BlogService'


  export default
  {
    components: {
      BannerBlog
    },


    data() {
    	return {
    		post: {
          title: null,
          img: null,
    			content: null,
    			created_at: null
    		}
    	}
    },


    mounted() {
    	this.getPost()
    },


    methods: {

    	async getPost()
    	{
    		const resp = await BlogService.getOne(this.$route.params.id)
        this.post.title = resp.data.title
        this.post.img = resp.data.img
    		this.post.content = resp.data.content
    		this.post.created_at = resp.data.created_at
    	},

    	dateFormat2(date)
			{
			  let d = new Date(date)
			  let months = Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');


			  let month = months[d.getMonth()]
			  let day = d.getDate().toString().padStart(2,'0')
			  let year = d.getFullYear()


			  return day + ' de ' + month + ' del ' + year
			}

    }
  }

</script>


